import { render, staticRenderFns } from "./PDFooter.vue?vue&type=template&id=690a6ffe&scoped=true&"
import script from "./PDFooter.vue?vue&type=script&lang=js&"
export * from "./PDFooter.vue?vue&type=script&lang=js&"
import style0 from "./PDFooter.vue?vue&type=style&index=0&id=690a6ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a6ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VFooter})
